<div class="hub-outer-container-top">
  <div class="bolt-container-fluid">
    <div class="bolt-row">
      <div class="bolt-col-12">
        <section>
          <nwx-notification-bar position="top"></nwx-notification-bar>
        </section>
        <section>
          <nwx-price-summary-container
            [maxSizeMedium]="maxSizeMedium$ | async"
            [awaitingProtectorVersionChoice]="awaitingProtectorVersionChoice"
            (showPdf)="getQuoteLetterPdf()"
          ></nwx-price-summary-container>
        </section>

        @if (!awaitingProtectorVersionChoice) {
          <div>
            @if (
              (selectedUnsupportedProducts$ | async) &&
              (maxSizeMedium$ | async) === false
              ) {
              <section
                >
                <nwx-unsupported-products-container>
                </nwx-unsupported-products-container>
              </section>
            }
            @if (hasExternalUnderlyPolicies$ | async) {
              <section>
                @if (hasExternalUnderlyPolicies$ | async) {
                  <bolt-notification
                    type="warning"
                    >
                    <div class="bolt-row">
                      <div class="bolt-col-10">
                        External underlying policies require underwriting approval.
                        Please continue to PolicyCenter to issue.
                      </div>
                      <div class="bolt-col-2">
                        <bolt-button type="solid" (click)="continueToPC()"
                          >Continue to PolicyCenter</bolt-button
                          >
                        </div>
                      </div>
                    </bolt-notification>
                  }
                </section>
              }
              @if (hasSecondaryMatchFlag$ | async) {
                <section
                  class="notification"
                  id="uwReportsReview"
                  >
                  <nwx-notification-bubble type="info">
                    <div class="bolt-row">
                      <div class="bolt-col-10">
                        Please review all accident information on the reports and
                        underwriting tab.
                      </div>
                      <div class="bolt-col-2">
                        <bolt-button (click)="dismissNotification('uwReportsReview')"
                          >Dismiss</bolt-button
                          >
                        </div>
                      </div>
                    </nwx-notification-bubble>
                  </section>
                }
                <nwx-notification-bar position="bottom"></nwx-notification-bar>
                @if (showMVRDisclaimer) {
                  <section class="mvr-notification">
                    <nwx-notification-bubble type="info" size="sm" paddingsize="sm">{{
                      mvrDisclaimerText
                    }}</nwx-notification-bubble>
                  </section>
                }
                @if (!(quoteHasRiskFilterErrors$ | async)) {
                  <section>
                    <nwx-persona-display
                      [personaReport]="personaReport$ | async"
                    ></nwx-persona-display>
                  </section>
                }
                @if (hasDfBlockedByPropertyIssue$ | async) {
                  <section>
                    <nwx-df-blocked-property-card
                      [selectedProducts]="(products$ | async) || []"
                    ></nwx-df-blocked-property-card>
                  </section>
                }
                @if ((maxSizeMedium$ | async) === false) {
                  <section>
                    <nwx-up-next-container></nwx-up-next-container>
                  </section>
                }
              </div>
            }
          </div>
        </div>
      </div>
    </div>

    @if (!awaitingProtectorVersionChoice) {
      <div class="hub-outer-container-bottom">
        <div class="bolt-container-fluid">
          @if ((selectedUnsupportedProducts$ | async) && (maxSizeMedium$ | async)) {
            <section
              >
              <div class="bolt-row">
                <div class="bolt-col">
                  <nwx-unsupported-products-container>
                  </nwx-unsupported-products-container>
                </div>
              </div>
            </section>
          }
          @if (maxSizeMedium$ | async) {
            <section>
              <div class="bolt-row">
                <div class="bolt-col">
                  <nwx-up-next-container></nwx-up-next-container>
                </div>
              </div>
            </section>
          }
          <div class="review-section">
            <div class="bolt-row">
              <div class="bolt-col-12">
                <section>
                  <nwx-review-policies-container
                    (scrollToTasks)="scrollToTasks()"
                  ></nwx-review-policies-container>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
    <div class="sticky-footer bolt-background-white button-bar-width-limiter">
      @if (showMVRDisclaimer) {
        <div
          class="mvr-notification-bottom bolt-space-inner-wide-lg"
          >
          @if (showMVRDisclaimer) {
            <nwx-notification-bubble
              type="info"
              size="sm"
              paddingsize="sm"
              >{{ mvrDisclaimerText }}</nwx-notification-bubble
              >
            }
          </div>
        }
        @if (!awaitingProtectorVersionChoice) {
          <bolt-button-bar
            class="bolt-background-white"
            >
            <bolt-button
              [disabled]="!quoteLetter"
              slot="cancel"
              [attr.id]="'hpc-quote-letter-pdf'"
              (click)="getQuoteLetterPdf()"
              iconright="download"
              size="lg"
              width="full-sm"
              >Quote PDF</bolt-button
              >
              @if (selectedUnsupportedProducts$ | async) {
                <bolt-button
                  slot="back"
                  iconleft="external-link"
                  (click)="launchUnsupportedModal()"
                  [attr.id]="'hpc-unsupported-modal'"
                  size="lg"
                  width="full-sm"
                  >
                  Quote PolicyCenter Products
                </bolt-button>
              }
              @if (nextStep$ | async; as nextStep) {
                @if (nextStep.buttonType === 'recalculate') {
                  <bolt-button
                    slot="forward"
                    iconleft="refresh"
                    (click)="onSubmit()"
                    [attr.id]="'hpc-reclaculate-quote'"
                    size="lg"
                    width="full-sm"
                    [disabled]="nextStep.buttonDisabled || null"
                    >
                    {{ nextStep.buttonLabel }}
                  </bolt-button>
                } @else {
                  @if (nextStep.buttonReady !== false) {
                    <bolt-button
                      slot="forward"
                      type="solid"
                      (click)="onSubmit()"
                      [iconright]="forwardButtonIcon"
                      attr.id="hpc-{{ nextStep.buttonLabel }}"
                      size="lg"
                      width="full-sm"
                      [disabled]="nextStep.buttonDisabled || null"
                      >
                      {{ nextStep.buttonLabel }}
                    </bolt-button>
                  } @else {
                    <div slot="forward" class="loading-outer">
                      <span class="loading">Loading</span>
                      <bolt-waiting-indicator minimal> </bolt-waiting-indicator>
                    </div>
                  }
                }
              }
            </bolt-button-bar>
          }
          @if (awaitingProtectorVersionChoice) {
            <bolt-button-bar
              class="bolt-background-white"
              >
              @if (awaitingProtectorVersionChoice) {
                <bolt-button
                  slot="forward"
                  type="solid"
                  (click)="submitVersionChoice(isProtectorVersionTabActive)"
                  iconright="arrow-right"
                  id="hpc-continue-version-choice"
                  size="lg"
                  width="full-sm"
                  [disabled]="false"
                  >
                  Continue with
                  {{ isProtectorVersionTabActive ? 'Protector' : 'Base' }} quote
                </bolt-button>
              }
              <!-- <div slot="forward" class="loading-outer">
              <span class="loading">Loading</span>
              <bolt-waiting-indicator minimal> </bolt-waiting-indicator>
            </div> -->
          </bolt-button-bar>
        }
      </div>
